<template>
  <div class="base-scoped-list-item" :class="finalClass">
    <div ref="item" class="el-upload-list__item-container">
      <div class="el-upload-list__item-wrap">
        <div class="el-upload-list__item-file">
          <div class="base-scoped-list-item__icons overflow-hidden truncate space-x-1.5">
            <label class="el-upload-list__item-status-label base-scoped-list-item__actions">
              <base-icon-clickable v-if="canBeOpen" custom="!block" 
                :class="{ 'rotate-180': isOpen }" size="xsm" name="chevrondown"
                @click="toggleOpen" />
              <slot name="actions" />
            </label>
            <label v-if="!hideStatus" class="base-scoped-list-item__status el-upload-list__item-status-label">
              <slot name="status" :item="item">
                <i v-if="status === Status.LOADING"
                  class="base-scoped-list-item__status-loading el-icon-upload-info el-icon-loading w-4 h-4"></i>
                <base-tooltip-icon v-else-if="itemstatuslabel" size="xsm" :content="itemstatuslabel"
                  :customClass="`!bg-transparent !dark:hover:base-icon-${itemstatus} align-text-top`"
                  :type="itemstatusicon" />
                <base-icon v-else size="xsm" :name="itemstatusicon"
                  :custom="`base-icon-${itemstatus} hover:base-icon-${itemstatus} dark:base-icon-${itemstatus} dark:hover:base-icon-${itemstatus} !bg-transparent !dark:hover:base-icon-${itemstatus} align-text-top rounded-full`" />
              </slot>
            </label>
          </div>
          <a class="el-upload-list__item-name base-scoped-list-item__name" @click="handleClick">
            <slot name="default" :item="item">
              {{ label }}
            </slot>
          </a>
        </div>
      </div>
    </div>
    <base-scoped-list v-if="canBeOpen && isOpen" class="zip-item-list ml-3" v-on="$listeners" v-bind="$props"
      :items="items" :deep="childDeep" none-space>
      <template v-if="$slots.default || $scopedSlots.default" slot="default" slot-scope="{ item }">
          <slot name="default" :item="item" />
        </template>
        <template v-if="$slots.actions || $scopedSlots.actions" slot="actions" slot-scope="{ item }">
          <slot name="actions" :item="item" />
        </template>
        <template v-if="$slots.status || $scopedSlots.status" slot="status" slot-scope="{ item }">
          <slot name="status" :item="item" />
        </template>
    </base-scoped-list>
  </div>
</template>
  
<script>
import ScopedItemProperties from '@/classes/scoped-list/ScopedItemProperties'
import Status from '@/classes/scoped-list/Status'
import getNestedValue from '@/services/functions/getNestedValue'
  
export default {
  name: 'base-scoped-list-item',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    listName: {
      type: String,
      default: 'el-list'
    },
    hideOpenAction: {
      type: Boolean,
      default: false
    },
    hideStatus: {
      type: Boolean,
      default: false
    },
    hideOpenItemActionsCallback: {
      type: Function,
      default: item => false
    },
    hideStatusItemCallback: {
      type: Function,
      default: item => false
    },
    defaultOpenAll: {
      type: Boolean,
      default: false
    },
    openOnClickNode: {
      type: Boolean,
      default: false
    },
    defaultOpenedKeys: {
      type: Array,
      default: () => []
    },
    deep: {
      type: [Number, Boolean],
      default: false
    },
    reverseColors: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: [String, Object],
      default: ''
    },
    props: {
      type: ScopedItemProperties,
      default: () => new ScopedItemProperties()
    }
  },
  data () {
    return {
      Status: Status,
      isOpen: !!this.defaultOpenAll || this.defaultOpenedKeys.includes(this.key)
    }
  },
  created () {
  },
  watch: {
  },
  computed: {
    listHeight: function () {
      return 100 - (this.$refs.item ? (parseFloat(getComputedStyle(this.$refs.item).height) + parseFloat(getComputedStyle(this.$refs.item.closest('li.el-upload-list__item')).marginTop)) : 0)
    },
    deepNumber: function () {
      return Math.max(Number(this.deep), 0)
    },
    childDeep: function () {
      return Math.max(this.deepNumber - 1, 0)
    },
    canBeOpen: function () {
      return !!(this.items?.length && !this.hideOpenAction && this.deepNumber)
    },
    finalClass: function () {
      return { clickable: this.canBeOpen || (!!this.$listeners.click && !this.items?.length) }
    },
    fixedProps: function () {
      return Object.assign(new ScopedItemProperties(), this.props)
    },
    label: function () {
      return getNestedValue(this.fixedProps.label, this.item) || ''
    },
    items: function () {
      return getNestedValue(this.fixedProps.items, this.item) || []
    },
    /** @returns {0|1|2|3|4} */
    status: function () {
      const status = getNestedValue(this.fixedProps.status, this.item) || Status.INFO
      return Math.min(Math.max(status, Status.LOADING), Status.INFO)
    },
    itemstatus: function () {
      switch (this.status) {
        case Status.LOADING:
          return 'loading'
        case Status.SUCCESS:
          return 'success'
        case Status.INFO:
          return 'info'
        case Status.WARNING:
          return 'warning'
        case Status.ERROR:
        default:
          return 'error'
      }
    },
    itemstatusicon: function () {
      return this.status && this.status !== Status.LOADING ? this.itemstatus : 'info'
    },
    itemstatuslabel: function () {
      return getNestedValue(this.fixedProps.statuslabel, this.item) || ''
    },
  },
  methods: {
    toggleOpen: function () {
      if (this.canBeOpen) {
        this.isOpen = !this.isOpen
      }
    },
    handleClick: function () {
      if (this.openOnClickNode) {
        this.toggleOpen()
      } else {
        this.$emit('click', this.item)
      }
    }
  },
}
</script>
  
  <style lang="scss" scoped>
  .center {
    margin: auto;
    width: 60%;
    border: none;
    padding: 1px;
  }
  
  .el-upload-list__item-container {
    position: relative;
    display: flex;
  }
  
  .el-upload-list__item-file,
  .el-upload-list__item-wrap {
    flex-grow: 1;
    width: 0;
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-content: flex-end;
  }
  
  .el-upload-list__item-name {
    margin-right: unset;
    flex-grow: 10;
  }
  
  .base-scoped-list-item__icons {
    display: flex;
    flex-direction: row;
    margin-right: 5px;
    overflow: visible;
    place-self: center;
  }
  
  .base-scoped-list-item__icons .el-upload-list__item-status-label,
  .base-scoped-list-item__icons .base-scoped-list-item__actions>* {
    position: relative;
  }
  
  .base-scoped-list-item__icons .base-scoped-list-item__actions>* {
    opacity: 0.75;
    color: var(--primary-500);
    right: unset;
    top: unset;
    @apply rounded-full;
  }
  
  .base-scoped-list-item__icons .base-scoped-list-item__actions>div {
    margin-block: auto;
  }
  
  .base-scoped-list-item__icons .base-scoped-list-item__actions>svg {
    top: -2px;
  }
  
  .dark .base-scoped-list-item__icons .base-scoped-list-item__actions>* {
    color: var(--darkblue-500);
    border-color: var(--darkblue-500);
  }
  
  .dark .base-scoped-list-item__icons .base-scoped-list-item__actions>*:hover {
    color: var(--darkblue-50);
    border-color: var(--darkblue-50);
    background-color: var(--darkblue-500);
  }
  
  .base-scoped-list-item__icons .el-upload-list__item-status-label {
    right: unset;
    display: unset;
    flex-direction: row-reverse;
  }
  
  .base-scoped-list-item__icons .el-upload-list__item-status-label>div {
    display: inline-block;
  }
  
  .base-scoped-list-item__icons .base-scoped-list-item__actions {
    display: none;
  }
  
  .el-upload-list__item:hover>.base-scoped-list-item>.el-upload-list__item-container .base-scoped-list-item__actions {
    display: flex;
  }
  
  .base-scoped-list-item__actions>* {
    display: inline-block;
    margin-inline: 5px;
  }
  
  .base-scoped-list-item__icons .base-scoped-list-item__actions:has(div:hover) {
    display: flex;
  }
  
  .base-scoped-list-item.clickable > .el-upload-list__item-container:hover {
    cursor: pointer;
  }
  .base-scoped-list-item.clickable > .el-upload-list__item-container:hover .base-scoped-list-item__name {
    color: var(--primary-500);
  }
  
  .el-upload-list__item.is-success .el-upload-list__item-name:focus,
  .el-upload-list__item.is-success .el-upload-list__item-name:hover {
    color: inherit;
    cursor: inherit;
  }
  
  .el-upload-list__item.is-success .base-scoped-list-item__icons .base-scoped-list-item__status {
    display: unset;
  }
  
  .el-upload-list__item.is-success .base-scoped-list-item__icons .base-scoped-list-item__actions {
    display: none;
  }
  </style>
